export default {
  category: 'web',
  action: 'mobile_download',
  labels: {
    android: 'android',
    ios: 'ios',
    windows: 'windows',
  },
};
